<template>
  <v-card>
    <v-card-title>
      <v-row>
        <v-col cols="12" sm="6"> 
          <span>Service Setting</span>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          :class="$vuetify.breakpoint.xs ? 'text-left' : 'text-right'"
        >
          <v-btn v-show="isAdmin"
            color="error"
            class="btn"
            @click="$emit(`remove`, details)"
            dark
            v-if="!userService.isDeleted"
            >Remove</v-btn
          >

          <v-btn
            color="info"
            class="btn"
            @click="$emit(`reactivate`, details)"
            dark
            v-else
            >Reactivate</v-btn
          >

          <v-btn
            color="info"
            class="ml-3"
            @click="$emit(`suspend`, details)"
            dark
            v-if="userService.lineStatus == 'Active' && suspendEnabled"
          >Suspend</v-btn
          >

          <v-btn
            color="info"
            class="ml-3"
            @click="$emit(`resume`, details)"
            dark
            v-else-if="userService.lineStatus == 'Suspended' && suspendEnabled"
          >Resume</v-btn
          >

          <v-btn color="dark" class="ml-3" dark @click="close">Close</v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-divider class="mx-4"></v-divider>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="4" lg="4" class="mb-10" v-show="isAdmin">
          <label for="radius-id"
            >Radius ID</label
          >
          <h3 class="mb-4 ">{{ userService.radiusServiceId }}</h3>
        </v-col>
        <v-col cols="12" md="4" lg="4" class="mb-10">
          <label for="radius-id"
            >Username</label
          >
          <h3 class="mb-4 ">{{ userService.radiusUsername }}</h3>
        </v-col>
        <v-col cols="12" md="4" lg="4" class="mb-10">
          <label for="radius-id"
            >Password</label
          >
          <h3 class="mb-4 ">{{ userService.radiusPassword }}</h3>
        </v-col>
        <v-col cols="12" md="4" lg="4" class="mb-10">
          <label for="radius-id">Static IP</label>
          <h3 class="mb-4 ">{{ getStaticIp ? getStaticIp : `-----` }}</h3>
        </v-col>
        <v-col cols="12" md="4" lg="4" class="mb-10">
          <label for="radius-id">Shape</label>
          <h3 class="mb-4 ">{{ userService.radiusShape ? userService.radiusShape : `-----` }}</h3>
        </v-col>
        <v-col cols="12" md="4" lg="4" class="mb-10">
          <label for="radius-id">Address</label>
          <h3 class="mb-4 ">{{ `${userService.serviceStreet ? userService.serviceStreet : ''} ${userService.serviceCity ? userService.serviceCity : ''}` }}</h3>
        </v-col>
        <v-col cols="12" md="4" lg="4" class="mb-10">
          <label for="radius-id">Billing Reference</label>
          <h3 class="mb-4 ">{{ userService.supplierBillingReference ? userService.supplierBillingReference : `-----` }}</h3>
        </v-col>
        <v-col cols="12" md="4" lg="4" class="mb-10">
          <label for="radius-id">Service ID</label>
          <h3 class="mb-4 ">{{ userService.serviceId ? userService.serviceId : `-----` }}</h3>
        </v-col>
        <v-col cols="12" md="4" lg="4" class="mb-10">
          <label for="radius-id">Service Name</label>
          <h3 class="mb-4 ">{{ userService.serviceName ?  userService.serviceName : `-----`}}</h3>
        </v-col>
        <v-col cols="12" md="4" lg="4" class="mb-10">
          <label for="radius-id">Rate Plan No.</label>
          <h3 class="mb-4 ">{{ userService.ratePlanId > 0 ? userService.ratePlanId : `-----` }}</h3>
        </v-col>
        <v-col cols="12" md="4" lg="4" class="mb-10">
          <label for="radius-id">Network Protocol</label>
          <h3 class="mb-4 ">{{ userService.isIPoE? 'IPoE' : `PPPoE` }}</h3>
        </v-col>
<!--        <v-col cols="12" md="4" lg="4" class="mb-10">-->
<!--          <label for="radius-id">IP Group</label>-->
<!--          <h3 class="mb-4 ">{{ userService.ipGroup ? userService.ipGroup : `-&#45;&#45;&#45;&#45;` }}</h3>-->
<!--        </v-col>-->
        <v-col cols="12" class="text-right">
          <v-btn
            color="dark"
            class="btn"
            :disabled="isEditable"
            @click="$emit(`edit`)"
            dark
            v-if="!userService.isDeleted"
            >Edit</v-btn
          >
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "service-settings",
  data: () => ({
    showPassword: false,
    confirmPassword: null,
    restartSession: false,
    shapes: [
      "Shape12Mbps",
      "Shape25Mbps",
      "Shape50Mbps",
      "Shape100Mbps",
      "Shape256Kbps",
    ],
  }),
  props: {
    isEditable: {
      type: Boolean,
      required: true,
    },
    userService: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    }
  },
  methods: {
    save() {
      let vm = this;
      vm.updateService(vm.restartSession);
      vm.$emit(`save`);
    },
    cancel() {
      this.$emit(`cancel`);
    },
    close() {
      let vm = this;
      vm.$router.push("/");
    },
  },
  computed: {
    getStaticIp(){
      let vm =this;
      if(vm.userService.radiusStaticIp != null && vm.userService.radiusStaticIp != '')
      {
        return vm.userService.radiusStaticIp
      }

      if(vm.userService.ipRange != null && vm.userService.ipRange != '')
      {
        return vm.userService.ipRange
      }
      return null;
    },
    suspendEnabled() {
      let vm =this;
      let flags = vm.$store.getters["featureFlag/allFlags"];
      return flags.sog5822;
    }
  }
};
</script>
